module.exports = __webpack_public_path__ + "img/class-portal-share-active.7a23b7f1.svg";